import { useEffect, useState } from "react";
import DynamicTable from "../ui/table/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import { RootState } from "../../utils/store/index";
import CustomModal from "../ui/CustomModal";
import CustomTable from "../ui/CustomTable";
import Accordion from "../ui/Accordion";
function ApplicationStatus({ ...props }) {
  const { ruralDetailsCount } = CustomHookForRuralDetails();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [typeData, setTypeData] = useState("");
  const propsData = props?.chartListData;
  const selector = useSelector((state: RootState) => state);
  const selectorData = useSelector((state: RootState) => state?.dynamicData);
  const isLoading = selectorData.loaders[`report/chart/${propsData?.id}`];
  const selectCompontData = (selector.chartListDetails as any)?.componentData
    ?.ALL?.[propsData?.id];
  const level2ChartId = propsData?.drill_down_chart_id;
  const level2PopupChartId = selectorData?.[level2ChartId]?.popup_chart_id;
  const level3ChartId = selectorData?.[level2ChartId]?.drill_down_chart_id;
  const level3PopupChartId = selectorData?.[level3ChartId]?.popup_chart_id;
  const activePopupChartId =
    typeData == "taluk"
      ? level2PopupChartId
      : typeData == "village"
        ? level3PopupChartId
        : selectCompontData?.popup_chart_id;
  const dispatch = useDispatch();
  const getSubData = async (rowId: string | number) => {
    const subData = {
      1: [
        { invoice: "INV-001", amount: "$200", date: "2024-03-01", items: 2 },
        { invoice: "INV-002", amount: "$150", date: "2024-03-02", items: 3 },
      ],
      2: [{ invoice: "INV-003", amount: "$300", date: "2024-03-03", items: 1 }],
      3: [
        { invoice: "INV-004", amount: "$400", date: "2024-03-04", items: 5 },
        { invoice: "INV-005", amount: "$250", date: "2024-03-05", items: 4 },
        { invoice: "INV-006", amount: "$100", date: "2024-03-06", items: 2 },
      ],
    };
    return (subData as any)[rowId] || [];
  };
  const columns = propsData?.columns;
  const applicationStatusData = async (id: number) => {
    await ruralDetailsCount(id, props);
  };
  const fetchPopupData = async (_data: string, type: any) => {
    // setIsModalOpen(true);
    if (type == "taluk") {
      setTypeData(type);
      setIsModalOpen(true);
      return await ruralDetailsCount(level2PopupChartId, props);
    } else if (type == "village") {
      setTypeData(type);
      setIsModalOpen(true);
      return await ruralDetailsCount(level3PopupChartId, props);
    } else if (type == "district") {
      setIsModalOpen(true);
      return await ruralDetailsCount(selectCompontData?.popup_chart_id, props);
    }
  };
  useEffect(() => {
    applicationStatusData(propsData?.id);
  }, []);
  return (
    <>
      {/* {isLoading && <DynamicLoader loading={isLoading} />} */}
      <div className={`bg-white rounded-lg p-3  ${props.width} `}>
        {/* <div className="flex justify-between items-center">
          <div className="text-[#464E5F] text-[14px] mb-0 pb-0 font-semibold">
            <label className=" font-roboto text-[14px] text-[#031B4E]  font-semibold block mb-2">
              {propsData?.title}
            </label>
          </div>
          <h2 className="text-lg font-semibold"></h2>
          <a href="#" className="text-blue-500">
            View all &rarr;
          </a>
        </div> */}
        {isLoading ? (
          <DynamicLoader loading={isLoading} />
        ) : (
          <div className="">
            <DynamicTable
              columns={columns}
              fetchData={selectorData[propsData?.id]}
              getSubData={getSubData}
              key={selectorData[propsData?.id]}
              applicationStatusData={applicationStatusData}
              has_drilldown={propsData?.has_drilldown}
              drill_down_chart_id={propsData?.drill_down_chart_id}
              id={propsData?.id}
              title={propsData?.title}
              fetchPopupData={fetchPopupData}
              chartListData={propsData}
            />
            <div className="mt-6">
              <Accordion title="AI Insights" componentID={propsData?.id} />
            </div>
          </div>
        )}
        <CustomModal
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          title="Chart Detail"
          size={props?.size || "md"}
        >
          <div>
            <CustomTable
              columns={selectorData?.[activePopupChartId]?.columns}
              isLoading={
                selectorData.loaders[`report/chart/${activePopupChartId}`]
              }
              rows={selectorData[activePopupChartId]?.rows}
              notes={selectorData[activePopupChartId]?.note}
              noteData={selectorData[activePopupChartId]?.remarks}
              title="Chart Detail"
              hideTitle={true}
            />
          </div>
        </CustomModal>
      </div>
    </>
  );
}
export default ApplicationStatus;
